import { fetchUsers } from '../client/user';
import { DEFAULT_BRAND_VALUE, offset, SORT_USERS } from '../constants';
import { isLocalStorageValueDefined } from './shared';

export const getNameForAvatar = (firstName, lastName, email) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  return firstName || lastName || email;
};

export const getPermissions = () => {
  const permissions = localStorage.getItem('permissions');
  return !permissions || !permissions.length ? '' : permissions;
};

export const getUsersBrand = () => {
  const brand = localStorage.getItem('brand');
  return isLocalStorageValueDefined(brand) ? brand : DEFAULT_BRAND_VALUE;
};

export const getUsersByParams = async ({
  page = 1,
  sort = SORT_USERS,
  search = '',
  sizePerPage = offset,
  withoutOrganization = false,
  excludeIds,
}) => {
  const { data } = await fetchUsers({
    PageNumber: page,
    PageSize: sizePerPage,
    Sort: sort,
    SearchTerm: search,
    withoutOrganization,
    ExcludeIds: excludeIds,
  });

  return data;
};

export const checkIsUserSuperAdmin = () =>
  getUsersBrand() === DEFAULT_BRAND_VALUE;
